
type WithWeight<T> = T & { weight: number };

const cumulativeWeightCache: WeakMap<Array<WithWeight<any>>, Array<number>> = new WeakMap();

/**
 * Selects a random item from a weighted array using binary search algorithm
 * instead of Array.find() or linear search for performance reasons.
 */
export const getWeightedRandom = <T>(items: Array<WithWeight<T>>): T => {

    if (items.length === 0) {
        throw new Error("Items must not be empty");
    }

    const getCumulativeWeights = (): Array<number> => {

        if (!cumulativeWeightCache.has(items)) {

            const cumulativeWeights: Array<number> = [];
            for (let i = 0; i < items.length; i++) {
                cumulativeWeights[i] = items[i].weight + (cumulativeWeights[i - 1] || 0);
            }

            cumulativeWeightCache.set(items, cumulativeWeights);
        }

        return cumulativeWeightCache.get(items)!;
    };

    const cumulativeWeights = getCumulativeWeights();
    const randomNumber = Math.random() * cumulativeWeights[cumulativeWeights.length - 1];

    let left = 0;
    let right = cumulativeWeights.length - 1;

    while (left < right) {
        const mid = Math.floor((left + right) / 2);
        if (cumulativeWeights[mid] >= randomNumber) {
            right = mid;
        } else {
            left = mid + 1;
        }
    }

    return items[left];
};